import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '@lt/localization';
import { EmptyReviews as EmptyReviewsIcon } from '@lt/components/icons-react/userflow';
import { TEST_ID_NOT_ENOUGH_REVIEW_TEXT } from './constants';

const NotEnoughReviews = ({ isEmptyReviews }) => {
  const { t } = useTranslation();
  const title = isEmptyReviews
    ? t('hotel.reviews.emptyTitle')
    : t('hotel.reviews.fewTitle');
  return (
    <StyledEmptyReviews $isEmptyReviews={isEmptyReviews}>
      {isEmptyReviews && <EmptyReviewsIcon width={165} />}
      <StyledTitle data-testid={TEST_ID_NOT_ENOUGH_REVIEW_TEXT}>
        {title}
      </StyledTitle>
      <StyledSubTitle>{t('hotel.reviews.emptySubtitle')}</StyledSubTitle>
    </StyledEmptyReviews>
  );
};

const StyledEmptyReviews = styled.div<{ $isEmptyReviews: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: #fff;
  height: 100%;
  border-radius: 4px;
  min-height: ${({ $isEmptyReviews }) => ($isEmptyReviews ? 524 : 316)}px;
`;

const StyledTitle = styled.div`
  font-weight: 700;
  font-size: 22px;
`;

const StyledSubTitle = styled.div`
  font-size: 14px;
`;

export default NotEnoughReviews;
